module.exports = __webpack_public_path__ + "static/media/kunshan04.5451fd6d.jpg";